import { Col, Row, Form, Input, Select, Space, Divider, InputNumber } from 'antd';
import {
    HeartOutlined,
    RocketOutlined,
    EditOutlined,
    EyeOutlined,
    ThunderboltOutlined,
    FireOutlined,
    DashboardOutlined,
    TrophyOutlined
} from '@ant-design/icons';

export const DetallesPokemon = ({
    detalleDatos,
    preevoluciones
}) => {
    return (
        <>
            <Divider orientation="left">
                <Space>
                    <HeartOutlined style={{ color: '#1890ff' }} />
                    <span>Detalles del Pokémon</span>
                </Space>
            </Divider>

            <Row gutter={[24, 16]}>
                <Col xs={24} md={12}>
                    <Form.Item
                        label={
                            <Space>
                                <RocketOutlined />
                                <span>Seudónimo</span>
                            </Space>
                        }
                        name='depo_seudonimo'
                    >
                        <Input
                            prefix={<RocketOutlined style={{ color: '#1890ff' }} />}
                            placeholder="Seudónimo del Pokémon"
                            style={{ borderRadius: '8px' }}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                    <Form.Item
                        label={
                            <Space>
                                <HeartOutlined />
                                <span>Descripción</span>
                            </Space>
                        }
                        name='depo_descripcion'
                    >
                        <Input.TextArea
                            placeholder="Descripción del Pokémon"
                            style={{ borderRadius: '8px' }}
                            rows={3}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={8}>
                    <Form.Item
                        label={
                            <Space>
                                <RocketOutlined />
                                <span>Altura (m)</span>
                            </Space>
                        }
                        name='depo_altura'
                    >
                        <InputNumber
                            placeholder="Altura en metros"
                            style={{ borderRadius: '8px', width: '100%' }}
                            min={0}
                            step={0.1}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={8}>
                    <Form.Item
                        label={
                            <Space>
                                <EditOutlined />
                                <span>Peso (kg)</span>
                            </Space>
                        }
                        name='depo_peso'
                    >
                        <InputNumber
                            placeholder="Peso en kilogramos"
                            style={{ borderRadius: '8px', width: '100%' }}
                            min={0}
                            step={0.1}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                    <Form.Item
                        label={
                            <Space>
                                <EyeOutlined />
                                <span>Pokémon Original</span>
                            </Space>
                        }
                        name='pokemon_original'
                    >
                        <Select
                            placeholder="Pokémon original (opcional)"
                            options={preevoluciones.data ?? []}
                            style={{ borderRadius: '8px' }}
                            allowClear
                            showSearch
                            filterOption={(input, option) =>
                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Divider orientation="left">
                <Space>
                    <TrophyOutlined style={{ color: '#1890ff' }} />
                    <span>Estadísticas</span>
                </Space>
            </Divider>

            <Row gutter={[24, 16]}>
                <Col xs={24} md={6}>
                    <Form.Item
                        label={
                            <Space>
                                <FireOutlined />
                                <span>Ataque</span>
                            </Space>
                        }
                        name='poke_ataque'
                        rules={[{ required: true, message: 'El ataque es obligatorio' }]}
                    >
                        <InputNumber
                            placeholder="Puntos de ataque"
                            style={{ borderRadius: '8px', width: '100%' }}
                            min={0}
                            max={999}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={6}>
                    <Form.Item
                        label={
                            <Space>
                                <ThunderboltOutlined />
                                <span>Poder Calculado</span>
                            </Space>
                        }
                        name='poke_poder_calculado'
                        rules={[{ required: true, message: 'El poder calculado es obligatorio' }]}
                    >
                        <InputNumber
                            placeholder="Poder calculado"
                            style={{ borderRadius: '8px', width: '100%' }}
                            min={0}
                            max={9999}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={6}>
                    <Form.Item
                        label={
                            <Space>
                                <RocketOutlined />
                                <span>Velocidad</span>
                            </Space>
                        }
                        name='poke_velocidad'
                        rules={[{ required: true, message: 'La velocidad es obligatoria' }]}
                    >
                        <InputNumber
                            placeholder="Puntos de velocidad"
                            style={{ borderRadius: '8px', width: '100%' }}
                            min={0}
                            max={999}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={6}>
                    <Form.Item
                        label={
                            <Space>
                                <HeartOutlined />
                                <span>Vida</span>
                            </Space>
                        }
                        name='poke_vida'
                        rules={[{ required: true, message: 'La vida es obligatoria' }]}
                    >
                        <InputNumber
                            placeholder="Puntos de vida"
                            style={{ borderRadius: '8px', width: '100%' }}
                            min={0}
                            max={999}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};
